import { Icon } from '@livable/saas-react-components';
import { Typography, Button, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
export default function InfoBlock(_ref) {
  var _info$details, _info$pods, _info$utilities, _info$buildings, _info$details2, _info$pods2, _info$utilities2, _info$utilities3, _info$buildings2;
  let info = _ref.info,
    stepIndex = _ref.stepIndex,
    handleEdit = _ref.handleEdit;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, info.title), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: handleEdit(stepIndex),
    'custom-attribute': '770-property-confirm-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }))), (((_info$details = info.details) === null || _info$details === void 0 ? void 0 : _info$details.length) > 0 || ((_info$pods = info.pods) === null || _info$pods === void 0 ? void 0 : _info$pods.length) > 0 || ((_info$utilities = info.utilities) === null || _info$utilities === void 0 ? void 0 : _info$utilities.length) > 0 || ((_info$buildings = info.buildings) === null || _info$buildings === void 0 ? void 0 : _info$buildings.length) > 0) && /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, ((_info$details2 = info.details) === null || _info$details2 === void 0 ? void 0 : _info$details2.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, info.details.map((infoRow, index) => /*#__PURE__*/React.createElement("div", {
    className: classes.infoRow,
    key: index
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.infoTitle
  }, infoRow.title, ":"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, infoRow.data)))), ((_info$pods2 = info.pods) === null || _info$pods2 === void 0 ? void 0 : _info$pods2.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, info.pods.map((pod, index) => /*#__PURE__*/React.createElement("div", {
    className: classes.pod,
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.infoRow
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.infoTitle
  }, "".concat(t('general.pod'), " #").concat(index + 1, " ").concat(t('general.address'), ":")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, pod.address)), /*#__PURE__*/React.createElement("div", {
    className: classes.infoRow
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.infoTitle
  }, "".concat(t('general.pod'), " #").concat(index + 1, " ").concat(t('general.square_footage'), ":")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, pod.squareFootage, " ft."))))), ((_info$utilities2 = info.utilities) === null || _info$utilities2 === void 0 ? void 0 : _info$utilities2.length) > 0 && /*#__PURE__*/React.createElement(TableContainer, {
    variant: "plain"
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "utilities table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('general.utility')), /*#__PURE__*/React.createElement(TableCell, null, t('add_new_property_flow.bill_frequency')), /*#__PURE__*/React.createElement(TableCell, null, t('add_new_property_flow.allocation_method')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('add_new_property_flow.cad_uppercase')))), /*#__PURE__*/React.createElement(TableBody, null, info.utilities.map((utility, index) => /*#__PURE__*/React.createElement(TableRow, {
    key: index
  }, /*#__PURE__*/React.createElement(TableCell, null, utility.utility), /*#__PURE__*/React.createElement(TableCell, null, utility.billFrequency), /*#__PURE__*/React.createElement(TableCell, null, utility.allocationMethod), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, utility.cad, "%")))))), ((_info$utilities3 = info.utilities) === null || _info$utilities3 === void 0 ? void 0 : _info$utilities3.length) === 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('add_new_property_flow.no_utilities_hint')), ((_info$buildings2 = info.buildings) === null || _info$buildings2 === void 0 ? void 0 : _info$buildings2.length) > 0 && /*#__PURE__*/React.createElement(TableContainer, {
    variant: "plain"
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "buildings table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('general.building')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('general.units')))), /*#__PURE__*/React.createElement(TableBody, null, info.buildings.map((building, index) => /*#__PURE__*/React.createElement(TableRow, {
    key: index
  }, /*#__PURE__*/React.createElement(TableCell, null, building.address), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, building.units))))))));
}